import { gql } from "@apollo/client";

const ROSTER_ENTRY_FIELDS = `
  userId
  name
  profilePicture
  guests
  childrenCount
  verdict
  recordedAt
  source
`;

export const EVENT_ATTENDANCE_FIELDS_FRAGMENT = gql`
  fragment EventAttendanceFields on EventAttendance {
    eventId
    eventTitle
    eventDate
    windowClosesAt
    isFinalized
    canEdit
    entries {
      ${ROSTER_ENTRY_FIELDS}
    }
  }
`;

export const PENDING_ATTENDANCE_REQUESTS_QUERY = gql`
  query PendingAttendanceRequests {
    pendingAttendanceRequests {
      eventId
      title
      date
      endDate
      windowClosesAt
      subscribersCount
      reportedCount
    }
  }
`;

export const EVENT_ATTENDANCE_QUERY = gql`
  query EventAttendance($eventId: ID!) {
    eventAttendance(eventId: $eventId) {
      ...EventAttendanceFields
    }
  }
  ${EVENT_ATTENDANCE_FIELDS_FRAGMENT}
`;

export const RECORD_EVENT_ATTENDANCE_MUTATION = gql`
  mutation RecordEventAttendance($input: RecordEventAttendanceInput!) {
    recordEventAttendance(input: $input) {
      success
      recordedCount
      entries {
        ${ROSTER_ENTRY_FIELDS}
      }
    }
  }
`;

export const DISMISS_ATTENDANCE_REQUEST_MUTATION = gql`
  mutation DismissAttendanceRequest($eventId: ID!) {
    dismissAttendanceRequest(eventId: $eventId)
  }
`;

/** Path of the attendance roster page of an event. */
export const eventAttendancePath = (eventId: string) =>
  `/events/${eventId}/attendance`;
